export default "__VITE_ASSET__DmEwHL20__"